module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"lastSubmission":"(last {dateTime})","action":{"fill":"Fill Form"}}}')
  delete Component.options._Ctor
}
